import { Store } from "utils";

class TemplateStore extends Store {
  getInitialState() {
    return {
      templates: [],
      selected: false,
      activeTemplate: [],
      previewTemplate: [],
      message: "",
      subject: "",
      textColor: "",
      color: "",
      logo: "",
    };
  }

  onTemplatesChanged(state, data) {
    state.templates = data.templates;
  }

  onActiveTemplate(state, data) {
    state.templates.map(function (item) {
      if (item.id == data) {
        state.message = item.content;
        state.subject = item.subject;
        state.textColor = item.textColor;
        state.color = item.color;
        state.logo = item.logo;
      }
    });
  }

  onPreviewTemplate(state, data) {
    if (data == "0") {
      return (state.previewTemplate = []);
    } else {
      state.templates.map(function (item) {
        if (item.id == data) {
          return (state.previewTemplate = item);
        }
      });
    }
  }

  onChangeActiveMessage(state, data) {
    return (state.message = data.message);
  }

  onChangeActiveSubject(state, data) {
    return (state.subject = data.subject);
  }

  onChangeActiveTextColor(state, data) {
    return (state.textColor = data.textColor);
  }

  onChangeActiveColor(state, data) {
    return (state.color = data.color);
  }

  onChangeActiveLogo(state, data) {
    return (state.logo = data.logo);
  }
}

const store = new TemplateStore();
export default store;



// WEBPACK FOOTER //
// ./src/modules/model/TemplateStore.js